import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from './image/logo4.svg';

const Header = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  
  const isActive = (path) => {
    return location.pathname === path;
  };

  const getLinkClasses = (path) => {
    const baseClasses = "px-3 py-2 rounded-md text-sm font-medium transition duration-200";
    if (isActive(path)) {
      return `${baseClasses} text-TerraNova-rust bg-TerraNova-rust/10 border-b-2 border-TerraNova-rust`;
    }
    return `${baseClasses} text-TerraNova-charcoal hover:text-TerraNova-rust hover:bg-TerraNova-rust/5`;
  };

  const getMobileLinkClasses = (path) => {
    const baseClasses = "block px-3 py-2 rounded-md text-base font-medium transition duration-200";
    if (isActive(path)) {
      return `${baseClasses} text-TerraNova-rust bg-TerraNova-rust/10 border-l-4 border-TerraNova-rust`;
    }
    return `${baseClasses} text-TerraNova-charcoal hover:text-TerraNova-rust hover:bg-TerraNova-rust/5`;
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="bg-white shadow-lg border-b-2 border-TerraNova-rust relative" style={{height: '80px'}}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16" style={{paddingTop: '12px'}}>
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <Link to="/" className="flex items-center text-2xl font-bold text-TerraNova-rust hover:text-TerraNova-clay transition duration-200">
                <img 
                  src={logo} 
                  alt="TerraNova Logo"
                  style={{ width: '210px', height: '250px', marginLeft: '-20px', zIndex: 0}}
                  className="h-8 w-auto mr-3"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </Link>
            </div>
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className={getLinkClasses('/')}>
              Home
            </Link>
            <Link to="/about" className={getLinkClasses('/about')}>
              About
            </Link>
            <Link to="/contact" className={getLinkClasses('/contact')}>
              Contact
            </Link>
            <div className="flex flex-col items-end space-y-1 text-TerraNova-rust font-medium">
              <div className="flex items-center space-x-2">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 7.89a2 2 0 002.83 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a 
                  href="mailto:Isaac@TerraNova.je"
                  className="text-sm hover:text-TerraNova-clay transition duration-200"
                >
                  isaac@terranova.je
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <a 
                  href="tel:07700777140"
                  className="text-sm hover:text-TerraNova-clay transition duration-200"
                >
                  <span className="text-sm">07700777140</span>
                </a>
              </div>
            </div>
          </div>
          
          {/* Mobile menu button and contact info */}
          <div className="md:hidden flex items-center space-x-3">
            <div className="flex items-center space-x-3">
              <a 
                href="tel:07700777140"
                className="flex items-center space-x-1 text-TerraNova-rust hover:text-TerraNova-clay transition duration-200"
                aria-label="Call us at 07700777140"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span className="text-xs font-medium">Call</span>
              </a>
            </div>
            <button
              onClick={toggleMobileMenu}
              className="text-TerraNova-charcoal hover:text-TerraNova-rust focus:outline-none focus:text-TerraNova-rust transition duration-200"
              aria-label="Toggle mobile menu"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isMobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>
      
      {/* Mobile menu panel - MOVED OUTSIDE CONTAINER */}
      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 z-50 bg-white border-t border-TerraNova-cream shadow-lg">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <Link 
                to="/" 
                className={getMobileLinkClasses('/')}
                onClick={closeMobileMenu}
              >
                Home
              </Link>
              <Link 
                to="/about" 
                className={getMobileLinkClasses('/about')}
                onClick={closeMobileMenu}
              >
                About
              </Link>
              <Link 
                to="/contact" 
                className={getMobileLinkClasses('/contact')}
                onClick={closeMobileMenu}
              >
                Contact
              </Link>
              <div className="px-3 py-2 border-t border-TerraNova-cream mt-2 pt-4">
                <div className="space-y-2">
                  <div className="flex items-center space-x-2 text-TerraNova-rust font-medium">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                    <a 
                      href="tel:07700777140"
                      className="text-sm hover:text-TerraNova-clay transition duration-200"
                    >
                      07700777140
                    </a>
                  </div>
                  <div className="flex items-center space-x-2 text-TerraNova-rust font-medium">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 7.89a2 2 0 002.83 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    <a 
                      href="mailto:Isaac@TerraNova.je"
                      className="text-sm hover:text-TerraNova-clay transition duration-200"
                    >
                      Isaac@TerraNova.je
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Header;
